import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { CTAButtons } from 'components';

import companyDetails from './CompanyDetails';
import generalDetails from './GeneralDetails';
import locations from './Locations';
import personalDetails from './PersonalDetails';
import importProducts from './ImportProducts';
import importCustomers from './ImportCustomers';
import posUsers from './PosUsers';

const subRoutes = [
  personalDetails,
  generalDetails,
  companyDetails,
  locations,
  posUsers,
  importProducts,
  importCustomers,
];

function Content() {
  const navigate = useNavigate();
  const buttons = {
    next: {
      onClick: () => navigate(personalDetails.path),
    },
  };
  return (
    <div className="flex-fill d-flex flex-column">
      <div className="jumbotron">
        <p>
          Configure your general settings by going through the following steps:
        </p>
        <ol>
          {subRoutes.map((route) => (
            <li key={route.path}>
              <Link to={`${route.path}`}>{route.title}</Link>
            </li>
          ))}
        </ol>
      </div>
      <CTAButtons buttons={buttons} />
    </div>
  );
}

export default {
  title: 'General Setup',
  path: '/setup',
  component: Content,
  rootPath: { name: 'General Setup' },
  subRoutes,
};

export { default as CompanyDetails } from './CompanyDetails';
export { default as GeneralDetails } from './GeneralDetails';
export { default as Locations } from './Locations';
export { default as PersonalDetails } from './CompanyDetails';
